import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// Default error page if no route is matched
const ErrorPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const logoutAndResetToLogin = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userOrganization");
    navigate("/");
  };

  toast.onChange((payload) => {
    if (payload.containerId === "infoToast") {
      toast.dismiss();
    }
  });

  return (
    <section className="page_404">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 ">
            <div className="col-sm-12 text-center">
              <div className="four_zero_four_bg"></div>
              {params?.errorType === "invalid_user_type" ? (
                <div className="contant_box_404">
                  <h3 className="h2">Access Denied.</h3>

                  <p>
                    Look like you don&apos;t have the right permissions yet!
                  </p>

                  <button
                    onClick={() => logoutAndResetToLogin()}
                    className="link_404">
                    Go back to Login
                  </button>
                </div>
              ) : (
                <div className="contant_box_404">
                  <h3 className="h2">Look like you&apos;re lost</h3>

                  <p>
                    The page that you are looking for is currently unavailable!
                  </p>

                  <a href="/" className="link_404">
                    Go to Home
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ErrorPage;
